import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';
import { KpiAnalyticsModel } from '../../../services-api-v2/kpi-follow-up/models/kpi-analytics.model';
import { ProcessEventsAndTClassBlocksModel } from '../../../services-api-v2/kpi-follow-up/models/process-events-and-t-class-blocks.model';

@Component({
    selector: 'app-kpi-planning-analytics-list-table',
    templateUrl: './kpi-planning-analytics-list-table.component.html',
    styleUrls: ['./kpi-planning-analytics-list-table.component.scss', '../../../../../assets/styles/kpi-styles/kpi-table-styles.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KpiPlanningAnalyticsListTableComponent implements OnChanges {

  @Input() processes: KpiAnalyticsModel[];
  @Input() plannedEventsAndTClassBlocks: ProcessEventsAndTClassBlocksModel;
  @Input() isProcessUnassigning: boolean;
  @Input() displayActionColumn: boolean;

  @ViewChild('periodBasedTable', { static: false }) periodBasedTable: MatTable<any>;

  @Output() tableDataToExport: EventEmitter<any> = new EventEmitter<any>();
  @Output() expandedElementChange: EventEmitter<KpiAnalyticsModel> = new EventEmitter<KpiAnalyticsModel>();
  @Output() optionSelectedBlocks: EventEmitter<any> = new EventEmitter();
  @Output() optionSelectedEvents: EventEmitter<any> = new EventEmitter();

  public dataSource: MatTableDataSource<KpiAnalyticsModel> = new MatTableDataSource();
  public expandedElement = null;
  public selectedTabIndex = 0;
  public total = 'TOTAL';

  public columnsToDisplay = ['name', 'durationPlanned', 'durationRealized', 'durationDeviation', 'productionLossRealized', 'revenueLossRealized', 'action'];
  public columnsToTranslate = [
    'KPI.PORTFOLIO.PLANNING_LIST_TABLE.PLANNING_CATEGORY',
    'KPI.PORTFOLIO.PLANNING_LIST_TABLE.DURATION_PLANNED',
    'KPI.PORTFOLIO.PLANNING_LIST_TABLE.DURATION_REALIZED',
    'KPI.PORTFOLIO.PLANNING_LIST_TABLE.DURATION_DEVIATION',
    'KPI.PORTFOLIO.PLANNING_LIST_TABLE.PROD_LOSS_REALIZED',
    'KPI.PORTFOLIO.PLANNING_LIST_TABLE.REV_LOSS_REALIZED',
    ''
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.processes?.currentValue) {
      const processes = changes.processes.currentValue;
      const total = processes.length > 0 ? this.calculateTotal(processes) : null;
      this.dataSource = new MatTableDataSource(total ? [...processes, total] : processes);
      this.exportTableData();
    }
  }

  public expandedElementClicked(event: KpiAnalyticsModel): void {
    if (!event || this.expandedElement !== event) {
      this.selectedTabIndex = 0;
    }
    this.expandedElement = this.expandedElement === event ? null : event;
    this.expandedElementChange.emit(event);
  }

  public optionSelectedBlocksFunc(option: any) {
    this.optionSelectedBlocks.emit(option);
  }

  public optionSelectedEventsFunc(option: any) {
    this.optionSelectedEvents.emit(option);
  }

  private calculateTotal(processes: KpiAnalyticsModel[]): KpiAnalyticsModel[] {
    return processes.reduce((acc: any, process: KpiAnalyticsModel) => {
      return {
        ...acc,
        durationPlanned: (acc.durationPlanned ? acc.durationPlanned : 0) + process.durationPlanned,
        durationRealized: (acc.durationRealized ? acc.durationRealized : 0) + process.durationRealized,
        durationDeviation: (acc.durationDeviation ? acc.durationDeviation : 0) + process.durationRealized - process.durationPlanned,
        productionLossRealized: (acc.productionLossRealized ? acc.productionLossRealized : 0) + process.productionLossRealized,
        revenueLossRealized: (acc.revenueLossRealized ? acc.revenueLossRealized : 0) + process.revenueLossRealized,
        name: this.total
      };
    }, {});
  }

  private exportTableData(): void {
    const int = interval(50).pipe(take(100)).subscribe(() => {
      // @ts-ignore
      if (this.periodBasedTable?._elementRef) {
        // @ts-ignore
        this.tableDataToExport.emit(this.periodBasedTable._elementRef.nativeElement);
        int.unsubscribe();
      }
    });
  }
}
